export default __webpack_public_path__ + "static/media/CurriculumAudio.f7ac31b8.svg";